module.exports = __webpack_public_path__ + "static/media/04n.f984fe91.svg";